
import { useState } from 'react';
import { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getUserAndRedirect } from '../../helpers/Functions';
import { LOGIN, SIGNUP, SIGNUP_MENU } from '../../navigation/Constants';
import { getOnboardingScreens } from '../../services/appSettingService';
import './slider.css';

export type BoardingSlider = {
    screenImage: string;
    screenOrder: number;
}

const OnBoardingSlider = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [sliders, setSliders] = useState<BoardingSlider[]>([]);
    const [sliderIndex, setSliderIndex] = useState<number>(0);
    const [animationClass, setAnimationClass] = useState<String>()
    const history = useHistory();

    useEffect(() => {
        getUserAndRedirect(history);
        getSliders();
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 10 * 1000);
        return () => clearInterval(interval);
    }, [sliderIndex])


    const getSliders = async () => {
        try {
            setIsLoading(true);
            const { data } = await getOnboardingScreens();
            setSliders(data);
        }
        catch (error: any) {
            console.error(error);
        }
        setIsLoading(false);
    };

    const nextSlide = () => {
        setAnimationClass('slide-from-right');
        if (sliderIndex !== (sliders.length - 1))
            setSliderIndex(prev => prev + 1);
        else
            setSliderIndex(0);
    };

    const prevSlide = () => {
        setAnimationClass('slide-from-left');
        if (sliderIndex !== 0)
            setSliderIndex(prev => prev - 1);
        else
            setSliderIndex(sliders.length - 1);
    };

    return (
        <div>
            <div className="tutorial_sec">
                <div data-animation="slide" className="tutorial_slider w-slider" style={{ overflow: 'hidden' }}>
                    {sliders.map((slide, index) => {
                        return (
                            <img
                                key={index}
                                src={slide.screenImage}
                                className={`${animationClass}`}
                                style={index !== sliderIndex ? { display: 'none' } : {}}
                            />
                        )
                    })}
                    <div className="tutorial_sl_ar w-slider-arrow-right" onClick={nextSlide}>
                        <div className="w-icon-slider-right"></div>
                    </div>
                    <div className="tutorial_sl_ar w-slider-arrow-left" onClick={prevSlide}>
                        <div className="w-icon-slider-left"></div>
                    </div>
                </div>
                <div className="tutorial_sl_nav w-slider-nav w-round">
                    {sliders.map((_, index) => {
                        return <div key={index} className={`w-slider-dot ${index === sliderIndex && 'w-active'}`}></div>
                    })}
                </div>
            </div>
            <div className="tutorial_but_group">
                <Link to={SIGNUP_MENU} className="tutorial_but w-button">
                    להצטרפות
                </Link>
                <Link to={LOGIN} className="tutorial_but grey w-button">
                    כניסה לחברים רשומים
                </Link>
            </div>
        </div>
    )
}




export default OnBoardingSlider;







{/* <div className="tutorial_but_group">
    <Link to={SIGNUP_MENU} className="tutorial_but w-button">
        יצירת משתמש חדש
    </Link>
    <Link to={LOGIN} className="tutorial_but grey w-button">
        כניסה למשתמש רשום
    </Link>
</div> */}